import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Icon,
  Grid,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Tooltip,
  TableRow,
  TableCell,
  Table,
  TableBody,
  Checkbox,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import { ReactSortable } from "react-sortablejs";

function CreateDataForm() {
  const title = "Create Data Form";
  usePageTitle(title);
  const navigate = useNavigate();

  //   const auth = useAuthUser();
  //   const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [dataFields, setDataFields] = useState([]);
  const [dataFormName, setDataFormName] = useState(null);
  // const [dataFormDescription, setDataFormDescription] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);
  // const [dataFormFields, setDataFormFields] = useState([]);

  const [openAddSectionDialog, setOpenAddSectionDialog] = useState(false);
  const [openAddFieldDialog, setOpenAddFieldDialog] = useState(false);
  const [dataFormSectionName, setDataFormSectionName] = useState(null);
  const [dataFormSectionDescription, setDataFormSectionDescription] = useState(null);

  const [formFieldType, setFormFieldType] = useState(null);
  const [formFieldDisplayName, setFormFieldDisplayName] = useState(null);
  const [formFieldKey, setFormFieldKey] = useState(null);
  const [formFieldOptions, setFormFieldOptions] = useState([]);
  const [formFieldValidationParams, setFormFieldValidationParams] = useState(null);
  const [selectedSection, setSelectedSection] = useState([]);
  const [formFieldEditable, setFormFieldEditable] = useState(false);

  const [isRelatedFields, setIsRelatedFields] = useState(false);
  const [relatedChildDisplayName, setRelatedChildDisplayName] = useState(null);
  const [relatedChildCustomKey, setRelatedChildCustomKey] = useState(null);
  const [openAddRelatedOptionsDialog, setOpenAddRelatedOptionsDialog] = useState(false);
  const [relatedParentOption, setRelatedParentOption] = useState(null);
  const [relatedChildOptions, setRelatedChildOptions] = useState(null);
  const [relatedOptions, setRelatedOptions] = useState([]);
  const [selectedRelatedOptionIndex, setSelectedRelatedOptionIndex] = useState(null);
  const [currentField, setCurrentField] = useState(null);
  const [fieldMeta, setFieldMeta] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("portal/data_forms/init.json")
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setDataFields(result.data.data.data_fields);
            // console.log(dataFields);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function createDataForm() {
    if (dataFormName === null) {
      setErrMsg("Form name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    // if (dataFormDescription === null) {
    //   setErrMsg("Form description is required");
    //   setSeverity("error");
    //   setOpen(true);
    //   return;
    // }

    if (dataFormSections.length <= 0) {
      setErrMsg("At least one form section is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    const passed = dataFormSections.every((section, index) => {
      if (section.fields.length <= 0) {
        console.log(index);
        setErrMsg(`${section.title} section requires at least one field`);
        setSeverity("error");
        setOpen(true);
        return false;
      }

      return true;
    });

    if (!passed) {
      return;
    }

    setShowLoading(true);
    const json = {
      title: `${dataFormName}`,
      // description: `${dataFormDescription}`,
      sections: dataFormSections,
    };
    console.log(json);

    await axios
      .post("portal/data_forms/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setTimeout(() => {
            navigate("/data-forms");
          }, 3000);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function removeSection(index) {
    const dfs = dataFormSections;
    setShowLoading(true);
    if (window.confirm(`Delete section?`) === true) {
      dfs.splice(index, 1);
      setDataFormSections(dfs);
    }
    setShowLoading(false);
  }

  function addField() {
    let metaData = fieldMeta;
    if (isRelatedFields) {
      if (relatedChildDisplayName === null) {
        setErrMsg("Second dropdown display name is required");
        setSeverity("error");
        setOpen(true);
        return;
      }
      if (relatedOptions === null) {
        setErrMsg("Related options are required");
        setSeverity("error");
        setOpen(true);
        return;
      }
      metaData = {
        related_fields: {
          child_name: relatedChildDisplayName,
          child_custom_key: relatedChildCustomKey,
          related_options: relatedOptions,
        },
      };
    }
    // console.log(metaData);

    if (currentField.field_type === "calculated_value") {
      if (metaData === null) {
        setErrMsg("Calculated value is not complete.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (metaData.operator === null || metaData.operator.length <= 0) {
        setErrMsg("Select a calculation type.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (metaData.fields.first.name === null || metaData.fields.first.name <= 0) {
        setErrMsg("First field display name required.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (metaData.fields.second.name === null || metaData.fields.second.name <= 0) {
        setErrMsg("Second field display name required.");
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    const dfs = dataFormSections;
    dfs[selectedSection].fields.push({
      field_type: formFieldType,
      display_name: formFieldDisplayName,
      custom_key: formFieldKey,
      options: formFieldOptions,
      validation_params: formFieldValidationParams,
      editable: formFieldEditable,
      meta: metaData,
    });
    // console.log(dfs);
    setDataFormSections(dfs);
    setOpenAddFieldDialog(false);
  }

  function removeField(index, idx) {
    const dfs = dataFormSections;
    setShowLoading(true);
    if (window.confirm(`Delete field?`) === true) {
      dfs[index].fields.splice(idx, 1);
      // console.log(dfs);
      setDataFormSections(dfs);
    }
    setShowLoading(false);
  }

  //   function setSortFormFields(index) {
  //     console.log(index);
  //     setDataFormFields([]);
  //   }

  const [validationParams, setValidationParams] = useState(null);
  // const [fieldOptions, setFieldOptions] = useState([]);
  const [showFieldOptions, setShowFieldOptions] = useState(false);

  useEffect(() => {
    setRelatedChildDisplayName(null);
    setRelatedChildCustomKey(null);
    setFieldMeta(null);
    setFormFieldDisplayName(null);
    setFormFieldKey(null);
    setFormFieldEditable(false);

    dataFields.every((param) => {
      if (param.reference === formFieldType) {
        if (param.validation_params.length > 0) {
          setValidationParams(param.validation_params);
        } else {
          setValidationParams(null);
        }
        if (param.options_reqd) {
          setShowFieldOptions(true);
        } else {
          setShowFieldOptions(false);
        }
        if (param.related_field) {
          setIsRelatedFields(true);
        } else {
          setIsRelatedFields(false);
        }
        // console.log(param);
        setCurrentField(param);
        return false;
      }
      return true;
    });
  }, [formFieldType]);

  function buildRelatedOptionsTable() {
    const items = [];
    relatedOptions.every((item, idx) => {
      items.push(
        <TableRow>
          <TableCell>
            <MDTypography variant="subtitle2" fontSize={14}>
              {item.parent}
            </MDTypography>
            <MDTypography variant="subtitle2" fontSize={10}>
              <Tooltip title="Edit">
                <MDButton
                  size="small"
                  iconOnly
                  onClick={() => {
                    setRelatedParentOption(item.parent);
                    setRelatedChildOptions(item.child);
                    setSelectedRelatedOptionIndex(idx);
                    setOpenAddRelatedOptionsDialog(true);
                  }}
                >
                  <Icon color="warning">edit</Icon>
                </MDButton>
              </Tooltip>
              &nbsp;&nbsp;
              <Tooltip title="Delete">
                <MDButton
                  size="small"
                  iconOnly
                  onClick={() => {
                    if (window.confirm("Delete?") === true) {
                      const tmp = relatedOptions;
                      delete tmp[idx];
                      setRelatedOptions(tmp);

                      setSeverity("warning");
                      setErrMsg("Related option deleted.");
                      setOpen(true);
                    }
                  }}
                >
                  <Icon color="error">delete</Icon>
                </MDButton>
              </Tooltip>
            </MDTypography>
          </TableCell>
          <TableCell>
            <MDTypography variant="subtitle2" fontSize={12}>
              {item.child}
            </MDTypography>
          </TableCell>
        </TableRow>
      );
      return true;
    });
    return items;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openAddRelatedOptionsDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Related Options</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox>
              <MDInput
                name="custom_key"
                margin="dense"
                label="First Dropdown Option"
                type="text"
                fullWidth
                placeholder="Ex. Country name, Category name"
                variant="outlined"
                value={relatedParentOption}
                onChange={(e) => setRelatedParentOption(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={relatedChildOptions}
                multiline
                minRows={3}
                name="form_options"
                margin="dense"
                label="Second Dropdown Options"
                placeholder="Ex. List of country's states, list of products of a category"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setRelatedChildOptions(e.target.value)}
              />
              <MDTypography variant="subtitle2" fontSize={10}>
                Comma separated values only.
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setSelectedRelatedOptionIndex(null);
              setRelatedParentOption(null);
              setRelatedChildOptions(null);
              setOpenAddRelatedOptionsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              if (relatedParentOption === null || relatedParentOption.length === 0) {
                return;
              }

              if (relatedChildOptions === null || relatedChildOptions.length === 0) {
                return;
              }

              const tmp = relatedOptions;
              if (selectedRelatedOptionIndex !== null) {
                tmp[selectedRelatedOptionIndex] = {
                  parent: relatedParentOption,
                  child: relatedChildOptions,
                };
              } else {
                tmp.push({
                  parent: relatedParentOption,
                  child: relatedChildOptions,
                });
              }

              console.log(tmp);
              setRelatedOptions(tmp);
              setOpenAddRelatedOptionsDialog(false);
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddSectionDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add Section</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="name"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionName(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                multiline
                rows={3}
                name="description"
                margin="dense"
                label="Description"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionDescription(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddSectionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              if (dataFormSectionName === null || dataFormSectionName.length < 3) {
                setSeverity("error");
                setErrMsg("Section name is required.");
                setOpen(true);
                return;
              }

              if (dataFormSectionDescription === null || dataFormSectionDescription.length < 3) {
                setSeverity("error");
                setErrMsg("Section description is required.");
                setOpen(true);
                return;
              }

              const dfs = dataFormSections;
              dfs.push({
                title: dataFormSectionName,
                description: dataFormSectionDescription,
                fields: [],
              });
              // console.log(dfs);
              setDataFormSections(dfs);
              setOpenAddSectionDialog(false);
            }}
          >
            Add Section
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddFieldDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Field</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Field Type</InputLabel>
                <Select
                  label="Field Type"
                  onChange={(e) => {
                    setFormFieldType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    dataFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      dataFields.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.name}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            {formFieldType && (
              <MDBox>
                {!isRelatedFields ? (
                  <MDBox>
                    {currentField && currentField.field_type !== "calculated_value" && (
                      <>
                        <MDBox mt={4}>
                          <MDInput
                            name="name"
                            margin="dense"
                            label="Display Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setFormFieldDisplayName(e.target.value)}
                          />
                        </MDBox>
                        <MDBox mt={2}>
                          <MDInput
                            name="custom_key"
                            margin="dense"
                            label="Custom Key (Optional)"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setFormFieldKey(e.target.value)}
                          />
                        </MDBox>
                        {validationParams && (
                          <MDBox mt={2}>
                            <MDBox p={1}>
                              <MDTypography variant="h6" fontWeight="medium">
                                Validation Options
                              </MDTypography>
                            </MDBox>
                            {
                              // --> Notice below changes
                              validationParams.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                validationParams.map((record) => {
                                  if (record.options) {
                                    return (
                                      <MDBox mt={3} mb={2}>
                                        <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                          <InputLabel>{record.name}</InputLabel>
                                          <Select
                                            label={record.name}
                                            onChange={(e) => {
                                              let params = formFieldValidationParams;
                                              if (params === null) {
                                                params = {};
                                              }
                                              params[record.key] = e.target.value;
                                              setFormFieldValidationParams(params);
                                            }}
                                            sx={{ padding: "12px", paddingLeft: "3px" }}
                                          >
                                            {
                                              // --> Notice below changes
                                              record.options.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                                record.options.map((opt) => (
                                                  <MenuItem value={`${opt.value}`}>
                                                    {opt.name}
                                                  </MenuItem>
                                                ))
                                            }
                                          </Select>
                                        </FormControl>
                                      </MDBox>
                                    );
                                  }

                                  return (
                                    <MDBox mb={2}>
                                      <MDInput
                                        name="custom_key"
                                        margin="dense"
                                        label={record.name}
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        onChange={(e) => {
                                          let params = formFieldValidationParams;
                                          if (params === null) {
                                            params = {};
                                          }
                                          params[record.key] = e.target.value;
                                          setFormFieldValidationParams(params);
                                        }}
                                      />
                                    </MDBox>
                                  );
                                })
                            }
                          </MDBox>
                        )}
                        {showFieldOptions && (
                          <MDBox mt={2}>
                            <MDInput
                              multiline
                              rows={3}
                              name="form_options"
                              margin="dense"
                              label="Field Options"
                              placeholder="Comma separated name:value pairs."
                              type="text"
                              fullWidth
                              variant="outlined"
                              onChange={(e) => setFormFieldOptions(e.target.value)}
                            />
                            <MDBox pl={1}>
                              <small>Ex: Male:M, Female:F, Mercedes:benz, Vehicle Type:SUV</small>
                            </MDBox>
                            <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
                              <Checkbox
                                checked={formFieldEditable}
                                onChange={(e) => {
                                  setFormFieldEditable(e.target.checked);
                                }}
                                inputProps={{ "aria-label": "controlled" }}
                              />
                              <MDTypography
                                variant="button"
                                fontWeight="regular"
                                color="text"
                                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                              >
                                &nbsp;&nbsp;Allow users enter preferred option?
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        )}
                      </>
                    )}

                    {currentField && currentField.field_type === "calculated_value" && (
                      <MDBox mt={3}>
                        {/* <MDBox pl={1}>
                          <MDTypography variant="h6" fontSize={14} fontWeight="bold">
                            Mathematical Calculation
                          </MDTypography>
                        </MDBox> */}
                        <MDBox mt={4}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Calculation Type</InputLabel>
                            <Select
                              label="Calculation Type"
                              onChange={(e) => {
                                let tmpOpts = fieldMeta;
                                if (tmpOpts === null) {
                                  tmpOpts = {
                                    operator: e.target.value,
                                    fields: {
                                      first: {
                                        name: null,
                                        key: null,
                                      },
                                      second: {
                                        name: null,
                                        key: null,
                                      },
                                    },
                                  };
                                }
                                tmpOpts.operator = e.target.value;
                                setFieldMeta(tmpOpts);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                            >
                              <MenuItem value="sum">Sum (Addition)</MenuItem>
                              <MenuItem value="difference">Difference (Substraction)</MenuItem>
                              <MenuItem value="product">Product (Multiplication)</MenuItem>
                              <MenuItem value="quotient">Quotient (Division)</MenuItem>
                              <MenuItem value="percentage">Percentage</MenuItem>
                            </Select>
                          </FormControl>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDBox pl={1}>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              First Field
                            </MDTypography>
                          </MDBox>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="name"
                                margin="dense"
                                label="Display Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => {
                                  let tmpOpts = fieldMeta;
                                  if (tmpOpts === null) {
                                    tmpOpts = {
                                      operator: "",
                                      fields: {
                                        first: {
                                          name: null,
                                          key: null,
                                        },
                                        second: {
                                          name: null,
                                          key: null,
                                        },
                                      },
                                    };
                                  }
                                  tmpOpts.fields.first.name = e.target.value;
                                  setFieldMeta(tmpOpts);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="custom_key"
                                margin="dense"
                                label="Custom Key (Optional)"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => {
                                  let tmpOpts = fieldMeta;
                                  if (tmpOpts === null) {
                                    tmpOpts = {
                                      operator: "",
                                      fields: {
                                        first: {
                                          name: null,
                                          key: null,
                                        },
                                        second: {
                                          name: null,
                                          key: null,
                                        },
                                      },
                                    };
                                  }
                                  tmpOpts.fields.first.key = e.target.value;
                                  setFieldMeta(tmpOpts);
                                }}
                              />
                            </Grid>
                          </Grid>
                        </MDBox>
                        <MDBox mt={2}>
                          <MDBox pl={1}>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              Second Field
                            </MDTypography>
                          </MDBox>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="name"
                                margin="dense"
                                label="Display Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => {
                                  let tmpOpts = fieldMeta;
                                  if (tmpOpts === null) {
                                    tmpOpts = {
                                      operator: "",
                                      fields: {
                                        first: {
                                          name: null,
                                          key: null,
                                        },
                                        second: {
                                          name: null,
                                          key: null,
                                        },
                                      },
                                    };
                                  }
                                  tmpOpts.fields.second.name = e.target.value;
                                  setFieldMeta(tmpOpts);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="custom_key"
                                margin="dense"
                                label="Custom Key (Optional)"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => {
                                  let tmpOpts = fieldMeta;
                                  if (tmpOpts === null) {
                                    tmpOpts = {
                                      operator: "",
                                      fields: {
                                        first: {
                                          name: null,
                                          key: null,
                                        },
                                        second: {
                                          name: null,
                                          key: null,
                                        },
                                      },
                                    };
                                  }
                                  tmpOpts.fields.second.key = e.target.value;
                                  setFieldMeta(tmpOpts);
                                }}
                              />
                            </Grid>
                          </Grid>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDBox pl={1}>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              Calculated Field
                            </MDTypography>
                          </MDBox>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="name"
                                margin="dense"
                                label="Display Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setFormFieldDisplayName(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="custom_key"
                                margin="dense"
                                label="Custom Key (Optional)"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setFormFieldKey(e.target.value)}
                              />
                            </Grid>
                          </Grid>
                        </MDBox>
                      </MDBox>
                    )}
                  </MDBox>
                ) : (
                  <MDBox>
                    <MDBox mt={3}>
                      <MDBox mb={3}>
                        <Alert severity="info">
                          <MDTypography variant="substitle1" fontSize={13} fontWeight="light">
                            Related dropdowns provide the ability to control options of a dropdown
                            based on the selected option of another dropdown.
                            <br />
                            <b>Example:</b>
                            <br />
                            Categories and products, Countries and states etc.
                          </MDTypography>
                        </Alert>
                      </MDBox>
                      <MDBox>
                        <MDBox>
                          <MDBox>
                            <MDTypography variant="h6" fontSize={14}>
                              First Dropdown
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <Grid container spacing={1}>
                              <Grid item xs={12} md={6} lg={6}>
                                <MDInput
                                  name="name"
                                  placeholder="Ex: Categories, Countries"
                                  margin="dense"
                                  label="Display Name"
                                  type="text"
                                  fullWidth
                                  variant="outlined"
                                  onChange={(e) => setFormFieldDisplayName(e.target.value)}
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={6}>
                                <MDInput
                                  name="custom_key"
                                  margin="dense"
                                  label="Custom Key (Optional)"
                                  type="text"
                                  fullWidth
                                  variant="outlined"
                                  onChange={(e) => setFormFieldKey(e.target.value)}
                                />
                              </Grid>
                            </Grid>
                          </MDBox>
                        </MDBox>
                        <MDBox mt={2}>
                          <MDBox>
                            <MDTypography variant="h6" fontSize={14}>
                              Second Dropdown
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <Grid container spacing={1}>
                              <Grid item xs={12} md={6} lg={6}>
                                <MDInput
                                  name="name"
                                  margin="dense"
                                  label="Display Name"
                                  placeholder="Ex: Products, States"
                                  type="text"
                                  fullWidth
                                  variant="outlined"
                                  defaultValue={relatedChildDisplayName}
                                  onChange={(e) => setRelatedChildDisplayName(e.target.value)}
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={6}>
                                <MDInput
                                  name="custom_key"
                                  margin="dense"
                                  label="Custom Key (Optional)"
                                  type="text"
                                  fullWidth
                                  variant="outlined"
                                  defaultValue={relatedChildCustomKey}
                                  onChange={(e) => setRelatedChildCustomKey(e.target.value)}
                                />
                              </Grid>
                            </Grid>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                    <MDBox mt={3} mb={3}>
                      <MDBox p={1} display="flex" justifyContent="space-between">
                        <MDBox>
                          <MDTypography variant="h6">Related Options</MDTypography>
                        </MDBox>
                        <MDBox>
                          <MDButton
                            variant="outlined"
                            color="dark"
                            size="small"
                            iconOnly
                            onClick={() => {
                              setSelectedRelatedOptionIndex(null);
                              setRelatedParentOption(null);
                              setRelatedChildOptions(null);
                              setOpenAddRelatedOptionsDialog(true);
                            }}
                          >
                            <Icon>add</Icon>
                          </MDButton>
                        </MDBox>
                      </MDBox>
                      <MDBox>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                                  First Dropdown
                                  <br />
                                  Option
                                </MDTypography>
                              </TableCell>
                              <TableCell>
                                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                                  Second Dropdown
                                  <br />
                                  Related Options
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            {buildRelatedOptionsTable()}
                          </TableBody>
                        </Table>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setFormFieldType(null);
              setValidationParams(null);
              setOpenAddFieldDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              if (formFieldType === null) {
                setSeverity("error");
                setErrMsg("Field type is required.");
                setOpen(true);
                return;
              }
              if (formFieldDisplayName === null || formFieldDisplayName === "") {
                setSeverity("error");
                setErrMsg("Field display name is required.");
                setOpen(true);
                return;
              }
              addField();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={1.5} pb={3} mb={3}>
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox>
                <Card sx={{ width: "100%", marginTop: "10px" }}>
                  <MDBox p={3}>
                    <MDTypography variant="h6" fontWeight="medium">
                      Data Form
                    </MDTypography>
                    <MDBox mt={2}>
                      <MDInput
                        name="name"
                        margin="dense"
                        label="Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setDataFormName(e.target.value)}
                      />
                    </MDBox>
                    {/* <MDBox mt={2}>
                      <MDInput
                        multiline
                        rows={3}
                        name="description"
                        margin="dense"
                        label="Description"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setDataFormDescription(e.target.value)}
                      />
                    </MDBox> */}
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox mt={3}>
                <Card sx={{ width: "100%", marginTop: "10px" }}>
                  <MDBox p={3}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDTypography variant="h6" fontWeight="medium">
                        Form Sections
                      </MDTypography>
                      <MDButton
                        variant="outlined"
                        color="dark"
                        iconOnly
                        size="small"
                        onClick={() => {
                          setOpenAddSectionDialog(true);
                          setDataFormSectionName(null);
                          setDataFormSectionDescription(null);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox>
                    <MDBox mt={3} id="sortableSections">
                      <ReactSortable list={dataFormSections} setList={setDataFormSections}>
                        {
                          // --> Notice below changes
                          dataFormSections.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            dataFormSections.map((record, index) => (
                              <MDBox mb={3}>
                                <Grid container spacing={0}>
                                  <Grid item xs={1} md={1} lg={1}>
                                    <MDBox display="flex" alignItems="center" pt={1}>
                                      <Icon fontSize="medium">swap_vert</Icon>
                                    </MDBox>
                                  </Grid>
                                  <Grid item xs={11} md={11} lg={11}>
                                    <MDBox mb={2}>
                                      <MDBox
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="right"
                                      >
                                        <MDBox df_ref={`${index}`}>
                                          <MDTypography variant="h6" fontWeight="regular">
                                            {record.title}
                                          </MDTypography>
                                        </MDBox>
                                        <MDBox align="right">
                                          <MDButton
                                            size="small"
                                            variant="outlined"
                                            iconOnly
                                            circular
                                            color="error"
                                            onClick={() => removeSection(index)}
                                          >
                                            <Icon>close</Icon>
                                          </MDButton>
                                        </MDBox>
                                      </MDBox>
                                      <MDBox>
                                        <MDTypography variant="h6" fontWeight="light">
                                          {record.description}
                                        </MDTypography>
                                      </MDBox>
                                    </MDBox>
                                  </Grid>
                                </Grid>
                              </MDBox>
                            ))
                        }
                      </ReactSortable>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Card sx={{ width: "100%", marginTop: "10px" }}>
                <MDBox p={3}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Form Fields
                  </MDTypography>
                </MDBox>
              </Card>
              <MDBox mt={3}>
                {
                  // --> Notice below changes
                  dataFormSections.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                    dataFormSections.map((record, index) => (
                      <MDBox mb={3}>
                        <Card sx={{ width: "100%", marginTop: "10px" }}>
                          <MDBox p={2}>
                            <MDBox
                              mb={2}
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <MDBox df_ref={`${index}`}>
                                <MDTypography variant="h6" fontWeight="bold">
                                  {record.title}
                                </MDTypography>
                              </MDBox>
                              <MDButton
                                variant="outlined"
                                color="dark"
                                size="small"
                                iconOnly
                                onClick={() => {
                                  setSelectedSection(index);
                                  setFormFieldType(null);
                                  setFormFieldDisplayName(null);
                                  setFormFieldKey(null);
                                  setFormFieldOptions(null);
                                  setFormFieldValidationParams(null);
                                  setValidationParams(null);
                                  setRelatedChildDisplayName(null);
                                  setRelatedChildCustomKey(null);
                                  setRelatedOptions([]);
                                  setIsRelatedFields(false);
                                  setFormFieldEditable(false);
                                  setOpenAddFieldDialog(true);
                                }}
                              >
                                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                              </MDButton>
                            </MDBox>
                            <MDBox>
                              {
                                // --> Notice below changes
                                record.fields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  record.fields.map((field, idx) => (
                                    <MDBox
                                      mb={2}
                                      pt={2}
                                      display="flex"
                                      justifyContent="space-between"
                                      alignItems="left"
                                    >
                                      <MDBox df_ref={`${index}`}>
                                        <MDTypography variant="caption" fontWeight="light">
                                          {field.field_name}
                                        </MDTypography>
                                        <MDTypography variant="h6" fontWeight="regular">
                                          {field.display_name}
                                          {field.validation_params !== null ? (
                                            <>
                                              <br />
                                              <small>
                                                {JSON.stringify(field.validation_params)}
                                              </small>
                                            </>
                                          ) : (
                                            <> </>
                                          )}
                                        </MDTypography>
                                        <MDTypography variant="caption" fontWeight="light">
                                          {field.options}
                                        </MDTypography>
                                      </MDBox>
                                      <MDButton
                                        size="small"
                                        variant="outlined"
                                        iconOnly
                                        circular
                                        color="error"
                                        onClick={() => removeField(index, idx)}
                                      >
                                        <Icon>close</Icon>
                                      </MDButton>
                                    </MDBox>
                                  ))
                              }
                            </MDBox>
                          </MDBox>
                        </Card>
                      </MDBox>
                    ))
                }
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mt={3}>
          <Card sx={{ width: "100%", marginTop: "10px" }}>
            <MDBox p={3} align="right">
              <MDButton
                color="dark"
                variant="contained"
                onClick={() => {
                  createDataForm();
                }}
              >
                Create Form
              </MDButton>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CreateDataForm;
